export default {
      id: "accounting-analysis-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#accounting-analysis",
      toString: function () {
        return this.url;
      }
    }